import React from 'react';
import Plot from './ThemedPlot';
import { normalizedWaveformTraces } from '../utils/waveformPlots';

export const WaveformModeSelector = ({ value, onChange, absoluteLabel = 'Absolute waveforms', populationLabel = 'Z-scored population', ariaLabel = 'Waveform display' }) => (
  <label className="waveform-mode-selector">Waveform display{' '}
    <select aria-label={ariaLabel} value={value} onChange={event => onChange(event.target.value)}>
      <option value="absolute">{absoluteLabel}</option>
      <option value="population">{populationLabel}</option>
      <option value="heatmap">Z-scored heatmap</option>
    </select>
  </label>
);

export const NormalizedWaveformPlot = ({ series, mode, selectedIds = [], onSelect, rowLabel = 'Cluster', showLegend = true }) => {
  const traces = normalizedWaveformTraces(series, mode, selectedIds);
  if (!traces.length) return <div className="no-data-message">No waveform samples available.</div>;
  return <Plot
    data={traces}
    layout={{ autosize: true, paper_bgcolor: 'transparent', plot_bgcolor: 'transparent',
      font: { color: '#a7b6c8', size: 11 }, margin: { l: 80, r: mode === 'heatmap' ? 70 : 20, t: 20, b: 45 },
      xaxis: { title: 'Time (ms)' },
      yaxis: mode === 'heatmap' ? { title: rowLabel, type: 'category', autorange: 'reversed' } : { title: 'Amplitude (z-score)' },
      showlegend: showLegend && mode === 'population', uirevision: mode,
    }}
    config={{ responsive: true, displaylogo: false }}
    style={{ width: '100%', height: '100%', minHeight: 180 }} useResizeHandler
    onClick={event => {
      const id = event.points?.[0]?.customdata;
      if (id !== undefined && id !== null) onSelect?.(id, {
        additive: Boolean(event.event?.ctrlKey || event.event?.metaKey || event.event?.shiftKey),
      });
    }}
  />;
};
